import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';

interface ErrorNotificationProps {
  message: string | null;
  onDismiss?: () => void;
  autoDismissTime?: number; // Time in ms before auto-dismissing
}

const ErrorNotification: React.FC<ErrorNotificationProps> = ({
  message, 
  onDismiss,
  autoDismissTime = 3000 // Default: 3 seconds
}) => {
  const [isVisible, setIsVisible] = useState(false);
  
  // When message changes, show/hide the notification
  useEffect(() => {
    if (message) {
      setIsVisible(true);
      
      // Auto-dismiss after specified time
      const timer = setTimeout(() => {
        setIsVisible(false);
        
        // After fade-out animation completes, clear the error
        const cleanupTimer = setTimeout(() => {
          if (onDismiss) onDismiss();
        }, 500); // Match this with CSS transition time
        
        return () => clearTimeout(cleanupTimer);
      }, autoDismissTime);
      
      return () => clearTimeout(timer);
    }
  }, [message, onDismiss, autoDismissTime]);
  
  // If no message, don't render anything
  if (!message) {
    return null;
  }
  
  return (
    <div className="mb-2 position-relative">
      <Alert 
        variant="danger" 
        className={`d-flex align-items-center py-2 px-3 ${isVisible ? 'fade-in' : 'fade-out'}`}
        style={{ zIndex: 1000 }}
      >
        <FeatherIcon 
          icon="alert-circle" 
          size={16} 
          className="text-danger me-2" 
        />
        <span className="fs--1">{message}</span>
      </Alert>
    </div>
  );
};

export default ErrorNotification;
